import Model from '../Model';
import {OrmConfig} from "@/pcm/types/vuex/OrmConfig";
import User from "@/pcm/store/models/User";
import Country from "@/pcm/store/models/Country";
import CreatorPaymentInformation from "@/pcm/store/models/CreatorPaymentInformation";
import CreatorNote from "@/pcm/store/models/CreatorNote";
import Contract from "@/pcm/store/models/Contract";
import Category from "@/pcm/store/models/Category";

export default class Creator extends Model {
    static entity = 'creators';

    static apiConfig: OrmConfig = {
        model: this.entity,
        name_prop: 'name',
    };

    static fields() {
        return {
            id: this.uid(),
            user_id: this.attr(null).nullable(),
            country_id: this.attr(null).nullable(),
            type: this.string('').nullable(),
            media_type: this.string('').nullable(),
            sign_type: this.string('').nullable(),
            name: this.string(''),
            pinyin: this.string(null).nullable(),
            alias: this.string('').nullable(),
            email: this.string(null).nullable(),
            address: this.string(null).nullable(),
            zip: this.string(null).nullable(),
            birthdate: this.string(null).nullable(),
            is_active: this.boolean('').nullable(),
            company: this.string(null).nullable(),
            chamber_of_commerce: this.string(null).nullable(),
            vat_number: this.string(null).nullable(),
            youtube_url: this.string(null).nullable(),
            facebook_url: this.string(null).nullable(),
            instagram_url: this.string(null).nullable(),
            twitter_url: this.string(null).nullable(),
            payment_method: this.string('').nullable(),

            created_at: this.string(''),
            updated_at: this.string(''),

            // Relations
            user: this.belongsTo(User, 'user_id'),
            country: this.belongsTo(Country, 'country_id'),
            creator_payment_information: this.hasOne(CreatorPaymentInformation, 'creator_id'),
            notes: this.hasMany(CreatorNote, 'creator_id'),
            contracts: this.hasMany(Contract, 'creator_id'),

            // Counts
            media_count: this.number(null).nullable(),

            // Pivot relations fix
            categories: this.attr(null),
            tags: this.attr(null),
        }
    }

    declare id: number;
    declare user_id: number;
    declare country_id: number;
    declare type: string;
    declare media_type: string;
    declare sign_type: string;
    declare name: string;
    declare pinyin: string | null;
    declare alias: string;
    declare email: string | null;
    declare address: string | null;
    declare zip: string | null;
    declare birthdate: string | null;
    declare is_active: boolean;
    declare company: string | null;
    declare chamber_of_commerce: string | null;
    declare vat_number: string | null;
    declare youtube_url: string | null;
    declare facebook_url: string | null;
    declare instagram_url: string | null;
    declare twitter_url: string | null;
    declare payment_method: string;
    declare contracts: Array<Contract>;
    declare country: Country | null;
    declare creator_payment_information: CreatorPaymentInformation | null;
    declare categories: Array<Category>;
}
